import {Booking} from '../../../modules/apps/booking/list/core/_models'
import {FetchModalPage} from './FetchModalPage'
import {FC} from 'react'

const FetchModalPageWrapper: FC<{error: any; booking: Booking | undefined}> = ({
  error,
  booking,
}) => {
  if (!error && booking) {
    return <FetchModalPage booking={booking} />
  }

  return null
}

export {FetchModalPageWrapper}
